import { useTranslation } from "react-i18next";

interface HomeFooterProps {
  onOpenPrivacyPolicy: () => void;
  onOpenTermsOfService: () => void;
}

/**
 * フッター。
 * ヒーローと同じビルの写真を敷き、文字は白く抜いたチップに載せて読めるようにしている
 * （オーナー指示 2026-09-11）。AI Labs はお役立ちリンクに既にあるのでここには置かない。
 * 管理者リンクも同指示で外した。
 */
export const HomeFooter = ({ onOpenPrivacyPolicy, onOpenTermsOfService }: HomeFooterProps) => {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p className="fc">
          &copy; {new Date().getFullYear()} {t("footer.copyright")}
        </p>
        <nav className="fnav" aria-label={t("footer.terms")}>
          <button type="button" onClick={onOpenPrivacyPolicy}>
            {t("footer.privacy_policy")}
          </button>
          <button type="button" onClick={onOpenTermsOfService}>
            {t("footer.terms")}
          </button>
        </nav>
      </div>
    </footer>
  );
};
